import React from 'react';

import './TypeButton.css';

const TypeButton = (props) => {
    const classes = ["btn","py-2","px-3","text-uppercase", "custom-max-content", "m-2"];

    if(props.selected){
        classes.push("custom-btn");
    }else{
        classes.push("custom-btn-inline");
    }

    return (
        <div className="d-inline">
            <button className={classes.join(' ')} onClick={props.click}>{props.text}</button>
        </div>
    );
};

export default TypeButton;